














import { Component, Prop, Vue } from 'vue-property-decorator'
import { CompExample } from '@/config/components/type'
import hljs from 'highlight.js/lib'
import 'highlight.js/styles/darcula.css'

@Component
export default class CodePreview extends Vue {
  @Prop() example!: CompExample

  mounted () {
    hljs.highlightBlock(this.$refs.source)
  }
}
